import { useContext, useMemo } from "react";

import { ConfigContext } from "../contexts/remoteConfig";

export const useRemoteConfig = () => {
  return useContext(ConfigContext);
};

export const useCategoryLabel = (categoryId) => {
  const { getValue } = useRemoteConfig();

  const tags = getValue("tags");

  return useMemo(() => {
    if (typeof tags === "string") {
      try {
        const tagsArray = JSON.parse(tags);

        const categoryLabel = tagsArray.find((tag) => tag.id === categoryId);

        return categoryLabel?.label;
      } catch (error) {
        return null;
      }
    } else {
      return null;
    }
  }, [categoryId, tags]);
};
